<wms-dialog id="unsavedChangesDialog_{{id}}" [content]="unsavedChangesContent" customClasses="modal small wm-studio-dialog fade wm-right-panel-container settings-dialog"
            [closeOnEscape]="false"  >
</wms-dialog>
<ng-template #unsavedChangesContent>
  <wms-dialog-header (onClose)="closeModal()"></wms-dialog-header>
  <wms-dialog-body>
    <p class="app-dialog-message">{{getMessage()}}</p>
  </wms-dialog-body>
  <wms-dialog-footer>
    <button class="cancel-action btn app-button btn-secondary" title="{{locale.LABEL_CANCEL}}"
            (click)="cancelChanges()"><span class="btn-caption">{{cancelBtnLabel}}</span></button>
    <button class="btn-primary ok-action btn app-button" title="{{locale.LABEL_OK}}" (click)="saveChanges()">
      <span class="btn-caption">{{saveBtnLabel}}</span></button>
  </wms-dialog-footer>
</ng-template>
